import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { listClass } from './styles';
import Meta from './Meta';
import Extra from './Extra';

var BaseItem =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(BaseItem, _PureComponent);

  var _super = _createSuper2(BaseItem);

  function BaseItem() {
    _classCallCheck(this, BaseItem);

    return _super.apply(this, arguments);
  }

  _createClass(BaseItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          extra = _this$props.extra,
          props = _objectWithoutProperties(_this$props, ["className", "extra"]);

      if (!extra) return (
        /*#__PURE__*/
        React.createElement(Meta, Object.assign({}, props, {
          className: className
        }))
      );
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: classnames(listClass('base'), className)
        },
        /*#__PURE__*/
        React.createElement(Meta, this.props),
        /*#__PURE__*/
        React.createElement(Extra, {
          extra: extra
        }))
      );
    }
  }]);

  return BaseItem;
}(PureComponent);

export default BaseItem;